module.exports = __webpack_public_path__ + "static/media/icefields-30.fe9768f8.jpg";